<template>
  <div class="network-status-info" v-if="connectionType !== 'none'">
    <p>网络状态: {{ connectionType }}</p>
    <p>延迟: {{ rtt }} 毫秒</p>
    <p>带宽: {{ downlink }} Mbps</p>
    <p>下载速度: {{ downloadSpeed }}</p>
  </div>
  <div class="network-status-info" v-else>
    <p>当前无网络连接</p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      connectionType: "",
      rtt: 0,
      downlink: 0,
      downloadSpeed: "测速中...",
    };
  },
  mounted() {
    this.updateConnectionInfo();
    navigator.connection.addEventListener("change", this.updateConnectionInfo);
    this.timer = setInterval(() => {
      this.updateConnectionInfo();
    }, 10000);
  },
  beforeDestroy() {
    clearInterval(this.timer); // 清除定时器
    navigator.connection.removeEventListener(
      "change",
      this.updateConnectionInfo
    );
  },
  methods: {
    // 更新网络连接信息
    updateConnectionInfo() {
      const connection = navigator.connection;
      this.connectionType = connection.effectiveType;
      this.rtt = connection.rtt;
      this.downlink = connection.downlink;
      this.measureNetworkSpeed();
    },

    // 网络测速
    measureNetworkSpeed() {
      var startTime = performance.now(); // 记录开始时间
      var xhr = new XMLHttpRequest(); // 创建 XMLHttpRequest 对象
      var timestamp = new Date().getTime();
      xhr.open(
        "GET",
        "https://resource.djp.org.cn/images/network.jpg?timestamp=" + timestamp
      );
      xhr.onload = function () {
        var endTime = performance.now(); // 记录结束时间
        var duration = endTime - startTime; // 计算请求耗时
        var downloadSpeed = this.calculateDownloadSpeed(
          xhr.responseText,
          duration
        ); // 计算下载速度
        this.downloadSpeed = this.formatSpeed(downloadSpeed);
        console.log("下载速度：" + this.downloadSpeed);
      }.bind(this);

      xhr.send(); // 发送请求
    },

    // 计算下载速度
    calculateDownloadSpeed(responseText, duration) {
      var fileSize = responseText.length; // 获取响应内容的大小，即文件大小
      var downloadSpeed = fileSize / (duration / 1000); // 计算下载速度，将文件大小除以时间（毫秒）并转换为秒
      return downloadSpeed;
    },

    // 网速单位
    formatSpeed(speed) {
      if (speed < 1000) {
        return speed.toFixed(2) + " b/s"; // 小于 1KB/s 使用字节/秒
      } else if (speed < 1000000) {
        return (speed / 1000).toFixed(2) + " Kb/s"; // 小于 1MB/s 使用千字节/秒
      } else {
        return (speed / 1000000).toFixed(2) + " Mb/s"; // 大于等于 1MB/s 使用兆字节/秒
      }
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/NetworkInfo.vue